import http from "./http_common";

class DietService {

    dietPlanHeaderSave(payload) {
        return http.post(
            `/dietPlanHeader/save`,
            payload
        );
    }
    dietPlanHeaderUpdate(payload) {
        return http.put(
            `/dietPlanHeader/update/${payload?.id}`,
            payload
        );
    }

    dietPlanHeaderList(payload) {
        var queryString = Object.keys(payload)
            .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
            .join("&");
        return http.get(
            `/dietPlanHeader/list/filter?${queryString}`);
    }
    dietPlanHeaderGet(id) {
        return http.get(
            `/dietPlanHeader/get/${id}`
        );
    }
    dietPlanHeaderDelete(id) {
        return http.delete(
            `/dietPlanHeader/delete/${id}`
        );
    }

    dietPlanSave(payload) {
        return http.post(
            `/patientDietPlan/save`,
            payload
        );
    }

    dietPlanUpdate(payload) {
        return http.put(
            `/patientDietPlan/update/${payload?.id}`,
            payload
        );
    }

    getDietList(payload) {
        var queryString = Object.keys(payload)
            .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
            .join("&");
        return http.get(`/patientDietPlan/list/filter?${queryString}`);
    }

    getDietById(payload) {
        return http.get(
            `/patientDietPlan/get/${payload}`
        );
    }
}

export default new DietService();
